// extracted by mini-css-extract-plugin
export default {"starRating":"ReviewStar_starRating__jb0cW","star":"ReviewStar_star__s6PIG","selected":"ReviewStar_selected__mkRsq"};